export const BORDER_COLORS_FOR_LOGOS = {
    'Meta':'#1877F2',  
    'Google Ads':'#34A853', 
    'LinkedIn':'#0F4B9B', 
    'Twitter':'#808080', 
    'TikTok':'rgb(0 0 0000000000 / 62%)'
}